import React, { useState } from 'react'

export const Accordion = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  return React.Children.map(children, (child, index) => React.cloneElement(child, {
    isActive: index === activeIndex,
    onHeaderClick: () => toggleItem(index),
  }))
}
